// Module
var code = "<h3 class=\"page-title portlet-page-title\"> <!-- ko text: _labels.MY_DAILY_STUFF --><!-- /ko --> </h3> <!--ko with: _portletSpace--> <!--ko template: {name: GetTemplateName.bind($data), afterRender: AfterRender.bind($data)}--><!--/ko--> <!--/ko --> ";
// Exports
export default code;